export default [
  {
    icon: 'mdi-pencil',
    title: 'Ubah Data',
    event: 'onEdit',
    akses: 'psp-peserta-kp.update',
  },
  {
    icon: 'mdi-delete',
    title: 'Hapus Kelompok',
    event: 'onDelete',
    akses: 'psp-peserta-kp.delete',
  },
];
